import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ButtonWithLoader } from '../../buttons/ButtonWithLoader';
import { S_Modal, S_ModalProps } from '../modal/S_Modal';

interface S_TwoButtonModalProps extends S_ModalProps {
  cancelText: string;
  disableSubmitButton?: boolean;
  submitText: string;
  loaderKey?: string;
  onSubmit: () => Promise<void>;
  onCancel: () => void;
  isLoading?: boolean;
  isStatic?: boolean;
}

export const S_ConfirmationModal = observer(
  (props: S_TwoButtonModalProps): ReactElement => (
    <S_Modal
      {...props}
      buttons={
        <>
          <Button
            color='neutral'
            variant='outlined'
            onClick={props.onCancel}
          >
            {props.cancelText}
          </Button>
          <ButtonWithLoader
            id='submit-button'
            color='primary'
            loaderKey={props.loaderKey}
            onClick={props.onSubmit}
            disabled={props.disableSubmitButton}
            loading={props.isLoading}
          >
            {props.submitText}
          </ButtonWithLoader>
        </>
      }
    />
  )
);
